import descriptor from './descriptorOffline'

export default {
  key: 'jobgrade',
  title: 'Job Grade',
  icon: 'project',
  manualFilter: { key: 'rate_type', value: 'pk' },
  contentProps: {
    urlTarget: '/job-management/job-grade',
    appName: 'jobs',
    modelName: 'jobgrade',
  },
  propsList: {
    avatar: 'level',
    masterKey: 'module-job-jobGrade',
    descriptor,
    availablePermissions: [], // jika array kosong, maka tidak ada filter. Jika tidak dikirim, default []
    // onAddClick: () => null, // can override or open urlTarget + /add
    // onDetailClick: () => null, // can override or open urlTarget + /:id
  }
}